import React from "react";
import { IconButton } from "@mui/material";
import PropTypes from "prop-types";
import { IMatchTrackProps } from "../../types/IMatchTrack";

const MatchTrack: React.FC<IMatchTrackProps> = ({ matches = [], onSelectMatchId }) => {
  return (
    <div className="team-logo-main">
      {matches.map((match, index) => (
        <React.Fragment key={index}>
          <div className="team-logos-wrapper">
            <span>{match.matchLabel}</span>
            <IconButton
              onClick={() => {
                onSelectMatchId(Number(match.matchId));
              }}
            >
              <img src={match.teamLogoURL} alt={match.matchLabel} />
            </IconButton>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

MatchTrack.propTypes = {
  matches: PropTypes.array,
};

export default MatchTrack;
